import { render, staticRenderFns } from "./ForeignDoctors.vue?vue&type=template&id=c263d75a&"
import script from "./ForeignDoctors.vue?vue&type=script&lang=js&"
export * from "./ForeignDoctors.vue?vue&type=script&lang=js&"
import style0 from "./ForeignDoctors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports